import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { LoginPartnerService } from '../services/partner/login-partner/login-partner.service';
import { Router, Route, ActivatedRoute } from '@angular/router';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MainService } from 'src/app/services/delavci/main.service';
import { Constants } from 'src/app/utils/constants';
import { AppConfigServiceService } from 'src/app/services/app-config-service.service';

@Component({
  selector: 'app-login-partner',
  templateUrl: './login-partner.component.html',
  styleUrls: ['./login-partner.component.css']
})
export class LoginPartnerComponent implements OnInit {

  public loginPartnerForm: UntypedFormGroup;
  public errorAtLogin: string;
  public alertClose = false;
  public submitted = false;
  public email = new UntypedFormControl('', Validators.email);
  public password = new UntypedFormControl('', );
  public assets;
  public showValidation;
  public navigateUrl;
  constructor(private loginPartnerService: LoginPartnerService, private mainService: MainService,
              private router: Router, private _snackBar: MatSnackBar, public MY_CONSTANTS: Constants,
              private appConfigService: AppConfigServiceService, private route: ActivatedRoute,) {

    if (this.loginPartnerService.currentPartnerValue) {
      this.router.navigate(['/pregled-helpdeska']);

    }

    if (this.mainService.currentUserValue) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.assets = this.appConfigService.apiAssets;
    this.navigateUrl = this.route.snapshot.queryParams['returnUrl'];

  }

  onLoginSubmit() {
    this.submitted = true;
    if (!this.mainService.currentUserValue) {
      this.loginPartnerService.getSession().subscribe( data => {
        const sessionUser = JSON.parse(JSON.stringify(data)).data.sessionUser;
        this.loginPartnerService.setCurrentSession(sessionUser);
        this.loginPartnerService.loginPartner(sessionUser, this.email.value, this.password.value)
        .subscribe( data => {
          if (data.data.email != null) {
            this.loginPartnerService.setCurrentPartner(data.data);
            if(this.navigateUrl) {
              this.router.navigate([this.navigateUrl]);
            } else {
              this.router.navigate(['/pregled-helpdeska']);
            }

          } else {
            this._snackBar.open('Neuspešna prijava', '', {
            duration: 2000,
          });
            this.submitted = false;
          }
        }, error => {
          this.submitted = false;
          console.log(error.error);
        });
      }, error => {
        this.submitted = false;
        this._snackBar.open('Neuspešna prijava', '', {
          duration: 2000,
        });
        console.log(error);
      });
    }
  }
  onZaposleni() {
    if(this.navigateUrl) {
      this.router.navigate(['/login'], { queryParams: { returnUrl: this.navigateUrl}});
    } else {
      this.router.navigate(['/login']);
    }

  }
}
